import { inferRouterOutputs } from '@trpc/server';
import { AppRouter } from '@tagadapay/trpc-types';

import { trpc } from './trpc';

type OutputRouter = inferRouterOutputs<AppRouter>;

export type CustomerPortalSettings = OutputRouter['customerPortal']['getSettings'];

/** Every operation the portal can offer, in the order the settings screen lists them. */
export const CUSTOMER_PORTAL_OPERATIONS = [
  'pause',
  'skip',
  'reschedule',
  'quantity',
  'frequency',
  'swapProduct',
] as const satisfies readonly (keyof CustomerPortalSettings)[];

/** The operations this screen manages; the settings carry more keys than the V2 card edits. */
export type CustomerPortalOperation = (typeof CUSTOMER_PORTAL_OPERATIONS)[number];

export function useCustomerPortalSettings(storeId: string) {
  return trpc.customerPortal.getSettings.useQuery({ storeId }, { enabled: !!storeId });
}

export function useUpdateCustomerPortalSettings() {
  const utils = trpc.useUtils();

  return trpc.customerPortal.updateSettings.useMutation({
    onSuccess: () => {
      utils.customerPortal.getSettings.invalidate();
    },
  });
}
